import React from "react";
import { useTranslation } from "react-i18next";

const HealingPanel = () => {
  const { t } = useTranslation("labels"); // Use the translation hook for the "labels" namespace

  // Translation keys
  const healing = t("healing");
  const graceWOG = t("graceWOG");
  const conventions = t("conventions");
  const conventionDetails = t("conventionDetails");
  const retreats = t("retreats");
  const retreatDetails = t("retreatDetails");
  const description = t("description");
  const healingWOG = t("healingWOG"); // "I am the Lord, who heals you."
  const healingQuote = t("healingQuote"); // "Exodus 15:26"
  return (
    <div className="container-fluid p-0" style={{ backgroundColor: "#f9f6f2" }}>
      {/* Title Section */}
      <div className="text-center mb-3 py-3">
        <h2 className="display-4">{healing}</h2> {/* Match heading style */}
        <p className="lead text-muted">{graceWOG}</p>{" "}
        {/* Match paragraph style */}
      </div>

      {/* Image and Overlay Section */}
      <div
        className="position-relative bg-cover bg-center"
        style={{
          height: "40vh",
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/international_banner-image-1.png)`,
        }}
      >
        <div className="d-flex h-100">
          <div
            className="col text-white p-3 d-flex flex-column justify-content-center"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <h3 className="text-light">{conventions}</h3> {/* Match color */}
            <p className="text-light">{conventionDetails}</p>
          </div>
          <div
            className="col text-white p-3 d-flex flex-column justify-content-center text-end"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <h3 className="text-light">{retreats}</h3> {/* Match color */}
            <p className="text-light">{retreatDetails}</p>
          </div>
        </div>
      </div>

      {/* Description Section */}
      <div className="text-center py-3">
        <p className="text-muted">
          <i>{healingWOG}</i>{" "}
          {/* Italicized text for "I am the Lord, who heals you." */}-{" "}
          <b>
            {healingQuote} {/* Exodus reference */}
          </b>
          <br />
          {description}
        </p>
      </div>

      {/* Link Section */}
      <div className="text-end py-2 px-3">
        <a href="/deliverance" className="btn btn-outline-primary">
        {t("viewMore")} <i className="bi bi-arrow-right-circle"></i>
        </a>
      </div>
    </div>
  );
};

export default HealingPanel;
